import { Injectable } from "@angular/core";
import { Observable, of, tap } from "rxjs";
import { SwUpdateStrategy } from "./SwUpdateStrategy";

@Injectable({
    providedIn: 'root',
})
export class SwUpdateImmediately implements SwUpdateStrategy {
    /**
     * @returns An Observable<boolean> containing the notification result:
     *          true -> update accepted by the user
     *          false -> update declined
     */
    public runUpdate(): Observable<boolean> {
        return of(true).pipe(
            tap(() => document.location.reload()),
        );
    }
}
